<template>
    <div>
        <dropper :index="index" :level="2"></dropper>
        <div  v-if="$parent.editMode"  class="delete is-pulled-right" @click="remove"></div>
        <div class="columns top10  " style="margin-bottom: 10px">
            <div class="column cmsComponentSmall ">
                <div class="columnDrop" :class="{removeBorder: !$parent.editMode}">
                    <colDrop :index="0"></colDrop>
                </div>
                  <!--  -->
                  <div ref="text" class="has-text-white top20">
                    <div v-show="focused !='text' || !$parent.editMode">
                        <div class="ql-snow top-20">
                            <div class="ql-editor  left-15" style="min-height: 0">
                                <div v-html="localTxt"  @click="setDirty('text')"></div>
                            </div>
                            <div v-show="!localTxt && $parent.editMode" class="is-size-7 has-text-grey top-10 left5" @click="focused = 'text'"><i>(html)</i></div>
                        </div>
                    </div>

                    <div v-show="$parent.editMode && focused=='text'">
                        <vue-editor :id="'editor0'"  v-model="localTxt" :editorToolbar="customToolbar"></vue-editor>
                        <button class="button is-coolGreen" @click="update('text')">APPLY</button>&nbsp;<button class="button" @click="cancel">CANCEL</button>
                    </div>
                </div>
                <!--  -->
            </div>
            <div class="column cmsComponentSmall ">
                <div class="columnDrop"  :class="{removeBorder: !$parent.editMode}">
                    <colDrop :index="1"></colDrop>
                </div>
                  <!--  -->
                  <div ref="text2" class="has-text-white top20">
                    <div v-show="focused !='text2' || !$parent.editMode">
                        <div class="ql-snow top-20">
                            <div class="ql-editor left-15" style="min-height: 0">
                                <div v-html="localTxt2"  @click="setDirty('text2')"></div>
                            </div>
                            <div v-show="!localTxt2  && $parent.editMode" class="is-size-7 has-text-grey top-10 left5" @click="focused = 'text2'"><i>(html)</i></div>
                        </div>
                    </div>

                    <div v-show="$parent.editMode && focused =='text2'">
                        <vue-editor :id="'editor1'"  v-model="localTxt2" :editorToolbar="customToolbar"></vue-editor>
                        <button class="button is-coolGreen" @click="update('text2')">APPLY</button>&nbsp;<button class="button" @click="cancel">CANCEL</button>
                    </div>
                </div>
                 <!--  -->
            </div>
            <div class="column cmsComponentSmall ">
                <div class="columnDrop"  :class="{removeBorder: !$parent.editMode}">
                    <colDrop :index="2"></colDrop>
                </div>
                 <!--  -->
                 <div ref="text3" class="has-text-white top20">
                    <div v-show="focused !='text3' || !$parent.editMode">
                        <div class="ql-snow top-20">
                            <div class="ql-editor left-15" style="min-height: 0">
                                <div v-html="localTxt3"  @click="setDirty('text3')"></div>
                            </div>
                            <div v-show="!localTxt3  && $parent.editMode" class="is-size-7 has-text-grey top-10 left5" @click="focused = 'text3'"><i>(html)</i></div>
                        </div>
                    </div>

                    <div v-show="$parent.editMode && focused =='text3'">
                        <vue-editor :id="'editor1'"  v-model="localTxt3" :editorToolbar="customToolbar"></vue-editor>
                        <button class="button is-coolGreen" @click="update('text3')">APPLY</button>&nbsp;<button class="button" @click="cancel">CANCEL</button>
                    </div>
                </div>
                 <!--  -->
            </div>
            <div class="column cmsComponentSmall ">
                <div class="columnDrop"  :class="{removeBorder: !$parent.editMode}">
                    <colDrop :index="3"></colDrop>
                </div>  
                <!--  -->
                 <div ref="text4" class="has-text-white top20">
                    <div v-show="focused !='text4' || !$parent.editMode">
                        <div class="ql-snow top-20">
                            <div class="ql-editor left-15" style="min-height: 0">
                                <div v-html="localTxt4"  @click="setDirty('text4')"></div>
                            </div>
                            <div v-show="!localTxt4  && $parent.editMode" class="is-size-7 has-text-grey top-10 left5" @click="focused = 'text4'"><i>(html)</i></div>
                        </div>
                    </div>

                    <div v-show="$parent.editMode && focused =='text4'">
                        <vue-editor :id="'editor1'"  v-model="localTxt4" :editorToolbar="customToolbar"></vue-editor>
                        <button class="button is-coolGreen" @click="update('text4')">APPLY</button>&nbsp;<button class="button" @click="cancel">CANCEL</button>
                    </div>
                </div>
                 <!--  -->
            </div>
        </div>
       
    </div>
</template>


<script>
import colDrop from './colDrop.vue'
import dropper from './sectionDropper.vue'
import { VueEditor } from "vue2-editor";
import { AZEventBus } from '../AZEventBus'

export default{
    props: {params: Object, index: Number},
    components: {dropper, colDrop, VueEditor},
    data: function(){
        return {
            imgId: 1,
            images: [],
            remImages: [],
            focused: false,
            localTxt: this.params.text ? this.params.text.split('**eq**').join('=') : '',
            localTxt2: this.params.text2 ? this.params.text2.split('**eq**').join('=') : '',
            localTxt3: this.params.text3 ? this.params.text3.split('**eq**').join('=') : '',
            localTxt4: this.params.text4 ? this.params.text4.split('**eq**').join('=') : '',
            customToolbar: [
                            [{
                    header: [false, 1, 2, 3, 4, 5, 6]
                }],
                ["bold", "italic", "underline", "strike"],
                [{
                        align: ""
                    }, {
                        align: "center"
                    }, {
                        align: "right"
                    }, {
                        align: "justify"
                }],
                [{ list: "ordered" }, { list: "bullet" }],
                ["link"],
                [{
                        indent: "-1"
                    }, {
                        indent: "+1"
                    }], // outdent/indent
                    [{
                        color: ['rgb(255,255,255)','rgb(241,194,50)','rgb(255,153,0)', 'rgb(150,150,150)']
                    }, {
                        background: []
                }]
            ]
        }
    },

    methods: {
        remove: function(){
            this.$parent.removeSection(this.index)
        },

        update: function(t){
          
          var self = this;
          this.focused = false

          if(t == 'text' && self.localTxt != this.dirty){
              this.localTxt = az.convertATagsToSelf(this.localTxt)
              this.$parent.source[this.index].params.text = this.localTxt.split('=').join('**eq**')
              AZEventBus.$emit('pageChanged', null)
          } else if(t == 'text2' && self.localTxt2 != this.dirty2){
              this.localTxt2 = az.convertATagsToSelf(this.localTxt2)
              this.$parent.source[this.index].params.text2 = this.localTxt2.split('=').join('**eq**')
              AZEventBus.$emit('pageChanged', null)
          } else if(t == 'text3' && self.localTxt3 != this.dirty3){
              this.localTxt3 = az.convertATagsToSelf(this.localTxt3)
              this.$parent.source[this.index].params.text3 = this.localTxt3.split('=').join('**eq**')
              AZEventBus.$emit('pageChanged', null)
          } else if(t == 'text4' && self.localTxt4 != this.dirty4){
              this.localTxt4 = az.convertATagsToSelf(this.localTxt4)
              this.$parent.source[this.index].params.text4 = this.localTxt4.split('=').join('**eq**')
              AZEventBus.$emit('pageChanged', null)
          }
          
      },

      cancel: function(){
          this.focused = false
          this.localTxt = this.$parent.source[this.index].params.text.split('**eq**').join('=')
          this.localTxt2 = this.$parent.source[this.index].params.text2.split('**eq**').join('=')
          this.localTxt3 = this.$parent.source[this.index].params.text3.split('**eq**').join('=')
          this.localTxt4 = this.$parent.source[this.index].params.text4.split('**eq**').join('=')
      },

      setDirty: function(t){
          if(this.$parent.editMode){
              this.focused = t
              if(t == 'text')
                  this.dirty = this.localTxt
              else if(t == 'text2')
                  this.dirty2 = this.localTxt2
              else if(t == 'text3')
                  this.dirty3 = this.localTxt3
              else if(t == 'text4')
                  this.dirty4 = this.localTxt4
          }
      }
    }
}


</script>